import React from "react";
import { Tag } from "antd";
import { BatchJob } from "reducers/types";

// "from → to" of a history job, with an "override" tag when the job replaces existing values.
export const rangeLabel = (job: BatchJob) => (
  <>
    {job.params.from} → {job.params.to}
    {job.params.override ? (
      <Tag color="orange" style={{ marginLeft: 8 }}>
        override
      </Tag>
    ) : null}
  </>
);
